<template>
  <div>
    <div class="section-header">
      <button class="align-center hide-at-xs" @click="createNewExercise" v-if="editable">
        <i class="material-icons clickable">add</i>
        Add
      </button>
      <h1>Exercises</h1>
      <div class="hide-at-xs">
        <h-input
          type="text"
          placeholder="Search"
          v-model="searchExercises"
          append-icon="search"
          @keyup="startSearch" />
        </div>
    </div>
    <!-- if statement is due to the vue keeps adding dups -->
    <div v-infinite-scroll="findNext" infinite-scroll-distance="40">
      <exercise-tile
        v-for="exercise in exercises" 
        :key="exercise.id" :exercise="exercise" 
        :editable="editable"
        @removeExercise="removeExercise(exercise)" 
        @edit="editExercise(exercise)"
        trashText="Remove"
        />
        <h3 class="small-top" v-if="busy">Loading...</h3>
    </div>
    <div class="card card--white" v-if="exercises.length == 0 && !busy">
      <div class="card card--container">
        <div class="text-helper" >You have no exercises for this Habit Program yet</div>
      </div>
    </div>
    <modal 
      v-if="newExercise" 
      title="Exercise"
      btn="Save"
      @saveExercise="saveExercise"
      >
        <exercise-form  
          @cancel="newExercise=false" 
          :exercise="newExerciseObj" 
          @saveExercise="saveExercise" 
          :areasOfFocus="areasOfFocus"
          @deleted="removedExercise"
          :editable="editable" />
    </modal>
    <error-modal title="Woops" btn="Close" v-if="displayWarning" @close="displayWarning=false" @submit="displayWarning=false">
      <div>Please create an Area of Focus before continuing</div>
    </error-modal>
  </div>
</template>

<script>
import Paginator from "@/services/api/paginator";
import exerciseTile from "./exerciseListTile";
import dataStore from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import modal from "@/components/modal";
import errorModal from "@/components/modal/default";
import User from "@/services/api/authUser";
import exerciseForm from "./exerciseForm";

export default {
  props: ["areasOfFocus", "editable", "habitProgramId", "canCreate", "userId"],
  data() {
    return {
      newExercise: false,
      newExerciseObj: { themes: [] },
      searchExercises: "",
      exercises: [],
      busy: false,
      displayWarning: false
    };
  },
  created() {
    this.exercises = [];
    this.startExercises();
  },
  methods: {
    createNewExercise() {
      if (!this.canCreate) {
        this.displayWarning = true;
        return;
      }
      this.newExercise = true;
      this.newExerciseObj = {
        owner: User.id,
        only_on: [],
        themes: []
      };
    },
    editExercise(exercise) {
      this.newExerciseObj = exercise;
      this.newExercise = true;
    },
    saveExercise(exercise) {
      if (exercise.id) {
        exercise.save();
        this.newExercise = false;
        snackbar.update("Saved");
        return;
      }
      this.newExerciseObj = {
        themes: []
      };
      dataStore
        .create("CoachHabitProgramTemplateExercises", exercise)
        .then(() => this.startExercises())
        .finally(() => {
          this.newExercise = false;
        });
    },
    destroy() {
      this.group.destroy().then(() => {
        snackbar.update("Deleted");
      });
    },
    removedExercise(exercise) {
      this.exercises = this.exercises.filter(e => e.id !== exercise.id);
      snackbar.update("Deleted");
      this.newExercise = false;
    },
    removeExercise(exercise) {
      if (!this.editable) {
        return;
      }
      dataStore
        .destroy("CoachHabitProgramTemplateExercises", exercise.id, {
          themes: exercise.themes
        }).then(() => this.removedExercise(exercise))
    },
    updateColor() {
      this.chooseNewColor = false;
      this.group.color = this.newColor.hex;
    },
    startSearch() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.startExercises();
      }, 300);
    },
    startExercises() {
      this.exercises = [];
      this.exercisePagination = new Paginator(
        "CoachHabitProgramTemplateExercises",
        {
          themes__areas_of_focus: this.habitProgramId,
          ordering: "-created_at",
          q: this.searchExercises
        }
      );
      this.findNext();
    },
    findNext() {
      if (this.busy || this.exercisePagination.finished) {
        return;
      }
      this.busy = true;
      this.exercisePagination.next().then(results => {
        this.exercises = [...this.exercises, ...results];
      }).finally(() => {
        this.busy = false;
      })
    },
    save() {
      this.$emit("saved", this.group);
    }
  },
  components: {
    exerciseTile,
    exerciseForm,
    modal,
    errorModal
  }
};
</script>